import Tooltip from 'zarm/lib/tooltip';

Tooltip.defaultProps.prefixCls = 'zw-tooltip';

export default Tooltip;
